/** Insère du texte à la position du curseur dans un textarea contrôlé. */
export const insertTextAtCursor = (
  textarea: HTMLTextAreaElement | null,
  text: string,
  value: string,
  setValue: (next: string) => void,
  maxLength?: number,
) => {
  if (!textarea) {
    let next = value + text;
    if (maxLength !== undefined && next.length > maxLength) {
      next = next.slice(0, maxLength);
    }
    setValue(next);
    return;
  }

  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  let next = value.slice(0, start) + text + value.slice(end);
  if (maxLength !== undefined && next.length > maxLength) {
    next = next.slice(0, maxLength);
  }
  setValue(next);
  requestAnimationFrame(() => {
    textarea.focus();
    const pos = Math.min(start + text.length, next.length);
    textarea.setSelectionRange(pos, pos);
  });
};
